import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import PostsType, { PostsTypeArr } from '../../defines/PostsType';
import PostServices from '../../services/PostServices';
import TimeUtils from '../../utils/TimeUtils';

const NewsSection = () => {
  const postPerLoad = 10;
  const [currentType, setType] = useState(PostsType.NEWS);
  const [posts, setPosts] = useState<any>([]);

  useEffect(() => {
    const getPosts = async () => {
      const _posts = await PostServices.getPostByType(
        currentType.param,
        0,
        postPerLoad
      );
      if (_posts) {
        setPosts(_posts);
      }
    };
    getPosts();
  }, [currentType]);

  return (
    <div className='news relative'>
      <div className='container mx-auto flex flex-col items-center'>
        <div className='news-title'></div>
        <div className='news-content grid grid-cols-1 lg:grid-cols-2 w-full'>
          <div className='news-sliders'>
            <div className='home-news-slider swiper'>
              <div className='swiper-wrapper'>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  loop
                  autoplay={{ delay: 5000 }}
                >
                  {posts.map((post: any, index: number) => {
                    return (
                      <SwiperSlide key={index}>
                        <div className='slide-item swiper-slide'>
                          <img
                            src={post.thumbnail}
                            alt='Banner'
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </div>
          <div className='news-table'>
            <div className='news-tabs'>
              {PostsTypeArr.map((postType, index) => {
                return (
                  <div key={index}
                    className={`tab ${
                      postType.param === currentType.param ? 'active' : ''
                    }`}
                    onClick={() => setType(postType)}
                  >
                    {postType.name}
                  </div>
                );
              })}
            </div>
            <div className='event-list'>
              {posts.map((post: any, index: number) => {
                return (
                  <Link key={index}
                    className='event-item'
                    to={`${currentType.path}/${post.path}/${post.postId}`}
                  >
                    <div className='event-title'>&nbsp;{post.title}</div>
                    <div className='event-time'>
                      {TimeUtils.getDateDDMMYYYY(post.time)}
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
